import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const TestimonialCard = ({ testimonial, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
      className="relative bg-charcoal/50 border border-white/5 p-8 hover:border-gold-500/20 transition-all duration-500"
      data-testid={`testimonial-card-${testimonial.id}`}
    >
      {/* Quote Icon */}
      <Quote className="absolute top-6 right-6 w-8 h-8 text-gold-500/20" />

      {/* Stars */}
      <div className="flex gap-1 mb-6">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-gold-500 text-gold-500" />
        ))}
      </div>

      {/* Content */}
      <p className="text-white/70 font-light leading-relaxed mb-8 italic">
        "{testimonial.content}"
      </p>

      {/* Author */}
      <div className="flex items-center gap-4">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-12 h-12 object-cover grayscale"
        />
        <div>
          <p className="font-serif text-white">{testimonial.name}</p>
          <p className="text-xs text-gold-500 uppercase tracking-wider">{testimonial.title}</p>
        </div>
      </div>
    </motion.div>
  );
};

const Testimonials = ({ testimonials }) => {
  return (
    <section id="testimonials" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-charcoal" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 space-y-4"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-gold-500 font-sans">Testimonials</p>
          <h2 className="text-4xl md:text-5xl font-serif text-white">
            Words of <span className="italic text-gold-400">Distinction</span>
          </h2>
          <p className="text-white/50 max-w-xl mx-auto">
            Hear from collectors and connoisseurs who have made Chronos part of their legacy.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
